import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { isNil } from '@web/utils';
import { EntryNotFoundException } from '@web/common';
import { SelectItem } from '@web/shared/ui';
import { AdminBackgroundTaskType } from '../enums/admin-background-task-type';

@Injectable({
  providedIn: 'root',
})
export class BackgroundTaskTypeProviderService {
  private readonly entries = new Map<AdminBackgroundTaskType, string>([
    [AdminBackgroundTaskType.OrderComplete, 'Masowa realizacja zamówień'],
    [AdminBackgroundTaskType.SimulateOrderComplete, 'Symulacja masowej realizacji zamówień'],
    [AdminBackgroundTaskType.OrderLabelsPackageGenerate, 'Generowanie zbiorczej paczki etykiet przesyłek'],
    [AdminBackgroundTaskType.SubscriptionProcess, 'Masowe procesowanie subskrypcji'],
    [AdminBackgroundTaskType.SubscriptionPriceChanging, 'Masowa zmiana cen subskrypcji'],
  ]);

  public labelFor(type: AdminBackgroundTaskType): Observable<string> {
    const result = this.entries.get(type);

    if (isNil(result)) {
      throw new EntryNotFoundException(
        `The entry for "${type}" is not found.`,
      );
    }

    return of(result);
  }

  public selectItems(): Observable<SelectItem<AdminBackgroundTaskType>[]> {
    return of(
      Array.from(this.entries.entries()).map(
        ([type, label]) => new SelectItem<AdminBackgroundTaskType>(label, type),
      ),
    );
  }
}
